// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608140834/js/" + chunkId + "." + {"44":"9e48b6f2","225":"06b8dc93","481":"0eced090","486":"bd1e37d0","770":"d39eb2ec"}[chunkId] + ".0.21738628292984297.chunk.js";
};